import { events, ROBOT_WS_ADDRESS } from "@/constants";
import { eventBus } from "@/utils/eventBus";
import { chatSdkHooks, WebSocketClient } from "@packages/chat-sdk";

export const robotWsClient = new WebSocketClient({
  wsAddress: ROBOT_WS_ADDRESS,
  onConnectStatusChange: () => void 0,
  onMessage: (data) => {
    eventBus.emit(events.robot, data);
  },
  onError: (data) => chatSdkHooks.common.wsErrorHook.emit(data),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});
